/* eslint-disable no-use-before-define */
import React from 'react'

export default ({dateRange, setDateRange, dataName="corporates-market-news-date-picker", size=6} = {}) =>
    <React.Fragment>
    <div className={"col-md-" + (12-size)}></div>
    <div className={"form-group col-md-"+size} style={{marginBottom:0}}>
    <label>Date Range</label>
    <div className="select-wrapper">
        <select
            data-name={dataName + '-select'}
            className="form-control"
            value={dateRange}
            onChange={(e) => setDateRange(e.target.value)}
        >
        {
            dateRanges.map((a, i) =>
                <option
                    name={dataName + '-option'}
                    key={i}
                    value={a.value}>{a.label}</option>
            )
        }
        </select>
    </div>
    </div>
    </React.Fragment>

const dateRanges = [
    {value:'today', label: 'Today'},
    {value:'this_week', label: 'This week'},
    {value:'this_month', label: 'This month'}
]
